import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "16",
  fill: "none",
  viewBox: "0 0 28 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#18d27b",
      d: "M10.499 3.5v1c0 4.814-2.686 7-6 7h-.95c.105-1.506.574-2.418 1.798-3.5.602-.533.551-.84.254-.664-2.041 1.215-3.055 2.857-3.1 5.48L2.499 13h-1c0-.681.058-1.3.173-1.866q-.173-.97-.173-2.634a5 5 0 0 1 5-5c1 0 2 .5 4 0M25.999 2v1.333c0 6.419-3.582 9.334-8 9.334H16.73c.14-2.009.766-3.224 2.398-4.668.803-.71.735-1.12.34-.884-2.723 1.62-4.075 3.81-4.135 7.305l-.002.247h-1.334c0-.909.078-1.734.231-2.488q-.23-1.295-.23-3.512A6.667 6.667 0 0 1 20.665 2C22 2 23.332 2.667 26 2"
    }, null, -1)
  ]))]))
}
export default { render: render }